import { render, staticRenderFns } from "./trustDetail.vue?vue&type=template&id=1ab99efe&scoped=true&"
import script from "./trustDetail.vue?vue&type=script&lang=js&"
export * from "./trustDetail.vue?vue&type=script&lang=js&"
import style0 from "./trustDetail.vue?vue&type=style&index=0&id=1ab99efe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab99efe",
  null
  
)

export default component.exports